import { SupplierRelationshipListResponseType } from "@sellar-io/api-v2/types";

import { DiscountItem } from "../../pages/customer/businessConnection/BusinessConnectionConvertDiscountsCard";
import {
  generateConnectionDiscountDescription,
  generateConnectionItemDiscountDescription,
} from "../../pages/customer/businessConnection/BusinessConnectionConvertDiscountsCard.shared";

export const getDiscountDescription = (
  connection: SupplierRelationshipListResponseType[number],
) => {
  return (
    <>
      {connection.Discounts.map((discount, idx) => {
        const text = generateConnectionDiscountDescription(discount);
        return <DiscountItem key={idx} text={text} />;
      })}
      {connection.ProductItemDiscounts.map((discount, idx) => {
        const text = generateConnectionItemDiscountDescription(discount);
        return <DiscountItem key={idx} text={text} />;
      })}
    </>
  );
};
